import useFeature from '~/client/hooks/feature/useFeature';
import useAgentData from '~/client/hooks/useAgentData';

const useIsBottomNavigation = () => {
  const { isMobile } = useAgentData();
  const isBottomNavigationEnabled = useFeature('isBottomNavigationEnabled');
  const isBottomNavigation = isMobile && isBottomNavigationEnabled;
  return isBottomNavigation;
};

export default useIsBottomNavigation;
